export default __webpack_public_path__ + "static/media/arrowBasic.611b7ffe.svg";